import { PageContainer } from '../../components/layout'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import CodeNotFoundContainer from '../../containers/404/code-not-found'
import type { NextPage } from 'next'

const NotFound: NextPage = () => {
  return (
    <PageContainer
      disableNotifications
      disableSideNav
      disableTopNav
      disableFooter
      overrideMobile
      page={Routes.CODE_NOT_FOUND}
    >
      <CodeNotFoundContainer />
    </PageContainer>
  )
}

export default NotFound
